(function () {
  var hasScrolled10 = false;
  var hasClicked = false;
  var hasHumanInteraction = false;
  var hasFired = false;

  var visibleTime = 0;
  var visibleStart = null;
  var timerInterval = null;

  function getScrollPercent() {
    var scrollTop = window.scrollY || window.pageYOffset;

    var docHeight =
      Math.max(
        document.body.scrollHeight,
        document.documentElement.scrollHeight
      ) - window.innerHeight;

    if (docHeight <= 0) return 100;

    return (scrollTop / docHeight) * 100;
  }

  function getVisibleTime() {
    var total = visibleTime;

    if (visibleStart !== null && document.visibilityState === 'visible') {
      total += Date.now() - visibleStart;
    }

    return total;
  }

  function tryFireEvent() {
    if (hasFired) return;

    var has30SecondsVisible = getVisibleTime() >= 30000;
    var hasEngagement = hasScrolled10 || hasClicked;

    if (!has30SecondsVisible) return;
    if (!hasEngagement) return;
    if (!hasHumanInteraction) return;

    hasFired = true;

    if (typeof fbq === 'function') {
      fbq('trackCustom', 'Engaged30sScroll10', {
        engagement_time_seconds: Math.floor(getVisibleTime() / 1000),
        scrolled_10_percent: hasScrolled10 ? 1 : 0,
        clicked: hasClicked ? 1 : 0,
        trusted_interaction: 1
      });
    }

    stopTimer();
    removeListeners();
  }

  function checkScroll(event) {
    if (getScrollPercent() >= 10) {
      hasScrolled10 = true;
      window.removeEventListener('scroll', checkScroll);
      tryFireEvent();
    }
  }

  function handleClick(event) {
    if (!event.isTrusted) return;

    hasHumanInteraction = true;
    hasClicked = true;

    document.removeEventListener('click', handleClick);

    tryFireEvent();
  }

  function markHumanInteraction(event) {
    if (!event.isTrusted) return;

    hasHumanInteraction = true;
    tryFireEvent();
  }

  function startVisibleTimer() {
    if (visibleStart === null) {
      visibleStart = Date.now();
    }

    if (timerInterval === null) {
      timerInterval = setInterval(function () {
        tryFireEvent();
      }, 1000);
    }
  }

  function pauseVisibleTimer() {
    if (visibleStart !== null) {
      visibleTime += Date.now() - visibleStart;
      visibleStart = null;
    }

    stopTimer();
  }

  function stopTimer() {
    if (timerInterval !== null) {
      clearInterval(timerInterval);
      timerInterval = null;
    }
  }

  function removeListeners() {
    window.removeEventListener('scroll', checkScroll);
    document.removeEventListener('click', handleClick);
    document.removeEventListener('pointerdown', markHumanInteraction);
    document.removeEventListener('touchstart', markHumanInteraction);
    document.removeEventListener('keydown', markHumanInteraction);
  }

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') {
      startVisibleTimer();
    } else {
      pauseVisibleTimer();
    }
  });

  window.addEventListener('scroll', checkScroll, {
    passive: true
  });

  document.addEventListener('click', handleClick);

  document.addEventListener('pointerdown', markHumanInteraction, {
    passive: true
  });

  document.addEventListener('touchstart', markHumanInteraction, {
    passive: true
  });

  document.addEventListener('keydown', markHumanInteraction);

  if (document.visibilityState === 'visible') {
    startVisibleTimer();
  }

  checkScroll();
})();